import JoyMedium from '../objects/JoyMedium';
import JoyChange from './JoyChange';
import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyDataService, { JoyDataServiceQueryOption } from '../services/JoyDataService';
import { isJoyStatusArray, isJoyPropertiesArray } from '../validation/ModelValidation';
import { isString } from '../validation/TypeChecking';
export default class JoyMediumsObserver {
    constructor(groupId, updateFunction, albumId, status, properties) {
        this.groupId = groupId;
        this.updateFunction = updateFunction;
        this.albumId = albumId;
        this.status = status;
        this.properties = properties;
        this.listener = null;
        this.data = new Map();
        this.data[JoyField.objectType] = JoyObjectType.medium;
        this.data[JoyField.group] = groupId;
        if (isString(albumId)) {
            this.data[JoyField.album] = albumId;
        }
        if (isJoyStatusArray(status)) {
            this.data[JoyField.status] = status;
        }
        if (isJoyPropertiesArray(properties)) {
            this.data[JoyField.props] = properties;
        }
    }
    notify(update) {
        this.updateFunction(update);
    }
    /**
     * Set the maximum number of JoyMedium objects that will be observed. 0 means all, negative value means the observer will stop.
     * @param count Number
     */
    setObservableCount(count) {
        this.dispose();
        this.listener = this.createListener(count);
        if (this.listener !== null) {
            this.listener.activate();
        }
    }
    /**
     * Remove the listener
     */
    dispose() {
        if (this.listener !== null) {
            this.listener.deactivate();
            this.listener = null;
        }
    }
    /**
     * Create a listener for Medium documents.
     * @param count The maximum number of documents to retrieve, 0 means all, negative value does nothing.
     */
    createListener(count) {
        if (count < 0) {
            return null;
        }
        let options = new Map();
        if (count > 0) {
            options[JoyDataServiceQueryOption.limit] = count;
        }
        return JoyDataService.instance.documentsListener(this.data, options, (mediumsData, changesData) => {
            let mediums = [];
            for (const data of mediumsData) {
                try {
                    mediums.push(new JoyMedium(data));
                }
                catch (error) {
                    throw Error('Invalid input for JoyMedium.');
                }
            }
            let changes = [];
            for (const data of changesData) {
                try {
                    changes.push(new JoyChange(data));
                }
                catch (error) {
                    throw Error('Invalid input for JoyChange.');
                }
            }
            this.notify([mediums, changes]);
        });
    }
}
//# sourceMappingURL=JoyMediumsObserver.js.map